// SIFEN Enums
export enum NaturalezaReceptorEnum {
    Contribuyente = 1,
    NoContribuyente = 2
}

export enum TipoContribuyenteEnum {
    PersonaFisica = 1,
    PersonaJuridica = 2
}

export enum TipoDocumentoIdentidadEnum {
    CedulaParaguaya = 1,
    Pasaporte = 2,
    CedulaExtranjera = 3,
    CarnetResidencia = 4,
    Innominado = 5,
    TarjetaDiplomatica = 6,
    Otro = 9
}

export enum TipoOperacionEnum {
    B2B = 1, // Business to Business
    B2C = 2, // Business to Consumer
    B2G = 3, // Business to Government
    B2F = 4  // Business to Foreign
}
